/**
 * The access token (LLD §6.1). Module-scoped: not localStorage, not
 * sessionStorage, not a readable cookie, not React state a devtools
 * extension can enumerate (PDD A-20). A reload loses it by design; the
 * session's bootstrap refresh restores it from the httpOnly cookie
 * (`session.tsx`). Every temptation to persist it here undoes A-20.
 *
 * The subscription is for reactivity only: subscribers learn that something
 * changed, never the token.
 */
let accessToken: string | null = null
const subscribers = new Set<() => void>()

const notify = (): void => {
  for (const fn of subscribers) fn()
}

export const tokenStore = {
  get: (): string | null => accessToken,
  set: (token: string): void => {
    accessToken = token
    notify()
  },
  clear: (): void => {
    if (accessToken === null) return
    accessToken = null
    notify()
  },
  /** Returns an unsubscribe function. */
  subscribe: (fn: () => void): (() => void) => {
    subscribers.add(fn)
    return () => {
      subscribers.delete(fn)
    }
  },
}
